import { useState } from "react";
import { PortableText } from '@portabletext/react';
import imageUrlBuilder from '@sanity/image-url'
import { client } from '../../sanityClient' // your configured sanity client
const builder = imageUrlBuilder(client)

const urlFor = (source) => builder.image(source)

const components = {
  marks: {
    en: ({ children }) => (
      <span className="font-outfit">{children}</span>
    ),
    jp: ({ children }) => (
      <span className="font-kleeone">{children}</span>
    ),
    link: ({ children, value }) => {
      const { href, openInNewTab } = value || {}
      return (
        <a
          href={href}
          target={openInNewTab ? "_blank" : "_self"}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          className="underline"
        >
          {children}
        </a>
      );
    },
  },
  block: {
    normal: ({ children }) => (
      <p className="font-outfit">{children}</p>
    ),
    h2: ({ children }) => (
      <h2 className="font-outfit">{children}</h2>
    ),
    h3: ({ children }) => (
      <h3 className="font-outfit">{children}</h3>
    ),
    // add more as needed (h3, blockquote, etc.)
    normal_jp: ({ children }) => (
      <p className="font-kleeone">{children}</p>
    ),
    h2_jp: ({ children }) => (
      <h2 className="font-kleeone">{children}</h2>
    ),
    h3_jp: ({ children }) => (
      <h3 className="font-kleeone">{children}</h3>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="">{children}</ul>
    ),
    number: ({ children }) => (
      <ol className="">{children}</ol>
    ),
  },
  listItem: {
    listItem: ({ children }) => (
      <li className="">{children}</li>
    ),
  },
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) return null; // safety check
      return (
        <div className="flex justify-center my-6">
          <img
            style={{ maxWidth: "100%" }}
            src={urlFor(value).url()} // build proper URL ....width(800)
            alt={value.alt || ""}
            className="" // your styling
          />
        </div>
      );
    },
  },
};

const ArticleItem = ({ number, title_en, title_jp, tags, type = false, preview, content, className }) => {
  const [readFlag, setReadFlag] = useState(false);

  // Collapsed: use the CMS-authored short `preview` if present (rendered in
  // full). If no preview is set, fall back to the original behavior of
  // showing the full paragraph with a 2-line clamp. Expanded: always show the
  // full paragraph uncramped.
  const hasPreview = Array.isArray(preview) && preview.length > 0;
  const displayedValue = readFlag ? content : (hasPreview ? preview : content);
  const clampFallback = !readFlag && !hasPreview;

  return (
    <div className={`article-item ${className}`}>
      <div className={`article-item-title ${type ? "title-active" : ""}`}>
        <div className={`title-wrapper ${type ? "sub-title-active" : ""}`}>
          <div className="title-main">
            {typeof number === "number" && (
              <div className="article-item-number font-amaticsc-bold">{number}</div>
            )}
            <h2
              className="item-title-en leading-[normal] font-amaticsc-bold"
            >
              {title_en}
              <p className="item-title-jp font-zenkurenaido">{title_jp}</p>
            </h2>
          </div>
          {tags && (
            <div className="article-item-tags-view">
              {tags.map((item, key) => {
                return (
                  <div className="article-tag-item leading-[30px]" key={key}>
                    <p className="tag-text1 font-amaticsc">{item.name_en}</p>
                    <p className="tag-text2 font-zenkurenaido">{item.name_jp}</p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {content && (
        <div className="article-item-content-view">
          <div className={`portable-text-container prose max-w-none w-full mx-0 prose-p:my-0 content-text ${clampFallback ? "" : "all-preview"} ${!readFlag && hasPreview ? "content-preview" : ""}`}>
            <PortableText value={displayedValue} components={components} />
          </div>

          <button
            type="button"
            onClick={() => setReadFlag(!readFlag)}
            className="continue-btn"
          >
            {readFlag ? "Less" : "Read More..."}
          </button>
        </div>
      )}
    </div>
  );
};

export default ArticleItem;
